import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import chunk from "lodash/chunk";

import StatsPanel from "../StatsPanel";
import reports from "./reports";

const ReportData = ({ report, period }) => (
  <Fragment>
    {chunk(reports, 3).map((reportsChunk, chunkIdx) => (
      <Row key={chunkIdx}>
        {reportsChunk.map(({ config, title }, idx) => (
          <Col md={4} key={idx}>
            <StatsPanel
              title={title}
              config={config}
              report={report}
              period={period}
            />
          </Col>
        ))}
      </Row>
    ))}
  </Fragment>
);

ReportData.propTypes = {
  period: PropTypes.string,
  report: PropTypes.string
};

export default ReportData;



// WEBPACK FOOTER //
// ./app/modules/HighScores/components/Report/ReportData.jsx